(function () {
    'use strict';

    angular
        .module('payroll')
        .config(PayrollRoute);

    /* @ngInject */
    function PayrollRoute($stateProvider) {
        $stateProvider
            .state ('root.payroll', {
                url: '/payroll',
                abstract: true
            })
            .state ('root.payroll.list', {
                url: '/list',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/payroll/list/list.html',
                        controller: 'PayrollListController',
                        controllerAs: 'payrollController'
                    }
                }
            });
    }
})();